(() => {
  const initProduct = (root) => {
    if (root.dataset.scReady === 'true') return;
    root.dataset.scReady = 'true';

    const currentProductId = String(root.dataset.productId || '');
    if (currentProductId) {
      try {
        const viewed = JSON.parse(localStorage.getItem('viewedProducts') || '[]').map(String);
        localStorage.setItem('viewedProducts', JSON.stringify([currentProductId, ...viewed.filter((id) => id !== currentProductId)].slice(0, 12)));
      } catch (_) {
        localStorage.setItem('viewedProducts', JSON.stringify([currentProductId]));
      }
    }

    const slides = [...root.querySelectorAll('[data-sc-slide]')];
    const thumbs = [...root.querySelectorAll('[data-sc-thumb]')];
    const mediaCurrent = root.querySelector('[data-sc-media-current]');
    let currentSlide = 0;
    const hydratePicture = (picture) => {
      if (!picture) return;
      picture.querySelectorAll('source[data-sc-srcset]').forEach((source) => {
        source.srcset = source.dataset.scSrcset;
        source.removeAttribute('data-sc-srcset');
      });
      const image = picture.querySelector('img[data-sc-src]');
      if (image) {
        image.src = image.dataset.scSrc;
        image.removeAttribute('data-sc-src');
      }
    };
    const loadSlideImage = (slide) => {
      const picture = slide?.querySelector('[data-sc-gallery-lazy]');
      if (!picture) return;
      hydratePicture(picture);
      picture.removeAttribute('data-sc-gallery-lazy');
    };
    const showSlide = (index, scrollThumb = false) => {
      if (!slides.length) return;
      currentSlide = (index + slides.length) % slides.length;
      loadSlideImage(slides[currentSlide]);
      slides.forEach((slide, i) => {
        slide.hidden = i !== currentSlide;
        slide.classList.toggle('is-active', i === currentSlide);
        slide.setAttribute('aria-hidden', i === currentSlide ? 'false' : 'true');
      });
      thumbs.forEach((thumb, i) => {
        thumb.classList.toggle('is-active', i === currentSlide);
        thumb.setAttribute('aria-pressed', i === currentSlide ? 'true' : 'false');
        if (i === currentSlide) thumb.setAttribute('aria-current', 'true');
        else thumb.removeAttribute('aria-current');
      });
      if (mediaCurrent) mediaCurrent.textContent = String(currentSlide + 1);
      if (scrollThumb) thumbs[currentSlide]?.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
    };
    thumbs.forEach((thumb) => thumb.addEventListener('click', () => showSlide(Number(thumb.dataset.scThumb), true)));
    root.querySelector('[data-sc-prev]')?.addEventListener('click', () => showSlide(currentSlide - 1, true));
    root.querySelector('[data-sc-next]')?.addEventListener('click', () => showSlide(currentSlide + 1, true));
    const stage = root.querySelector('.sc-pdp-stage');
    if (stage && slides.length > 1) {
      let touchStartX = 0;
      let touchStartY = 0;
      stage.addEventListener('touchstart', (event) => {
        touchStartX = event.changedTouches[0]?.clientX || 0;
        touchStartY = event.changedTouches[0]?.clientY || 0;
      }, { passive: true });
      stage.addEventListener('touchend', (event) => {
        const touch = event.changedTouches[0];
        if (!touch) return;
        const deltaX = touch.clientX - touchStartX;
        const deltaY = touch.clientY - touchStartY;
        if (Math.abs(deltaX) < 42 || Math.abs(deltaX) <= Math.abs(deltaY) * 1.2) return;
        showSlide(currentSlide + (deltaX < 0 ? 1 : -1), true);
      }, { passive: true });
    }

    const deferredPictures = [...root.querySelectorAll('[data-sc-deferred-picture]')];
    if ('IntersectionObserver' in window) {
      const deferredObserver = new IntersectionObserver((entries, observer) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          hydratePicture(entry.target);
          entry.target.removeAttribute('data-sc-deferred-picture');
          observer.unobserve(entry.target);
        });
      }, { rootMargin: '240px 0px' });
      deferredPictures.forEach((picture) => deferredObserver.observe(picture));
    } else {
      deferredPictures.forEach((picture) => {
        hydratePicture(picture);
        picture.removeAttribute('data-sc-deferred-picture');
      });
    }

    const quantity = root.querySelector('[data-sc-quantity]');
    root.querySelector('[data-sc-qty-minus]')?.addEventListener('click', () => { quantity.value = Math.max(1, Number(quantity.value || 1) - 1); });
    root.querySelector('[data-sc-qty-plus]')?.addEventListener('click', () => { quantity.value = Math.max(1, Number(quantity.value || 1) + 1); });

    const variantData = root.querySelector('[data-sc-variants]');
    const variants = variantData ? JSON.parse(variantData.textContent || '[]') : [];
    const optionInputs = [...root.querySelectorAll('[data-sc-option]')];
    const promotionEligible = root.dataset.promotionEligible === 'true';
    const labels = {
      add: root.dataset.labelAdd,
      soldOut: root.dataset.labelSoldOut,
      inStock: root.dataset.labelInStock,
      price: root.dataset.labelPrice,
      discountNoCode: root.dataset.labelDiscountNoCode
    };
    const renderPrice = (variant) => {
      if (variant.compareAtCents > variant.priceCents) return `<div class="sc-pdp-price sc-pdp-price--sale"><strong>${variant.price}</strong><s>${variant.compareAt}</s></div>`;
      if (!promotionEligible) return `<div class="sc-pdp-price"><strong>${variant.price}</strong></div>`;
      return `<div class="sc-pdp-price"><strong>${variant.price}</strong></div><p class="sc-pdp-promo-note">${labels.discountNoCode}</p>`;
    };
    const updateVariant = (updateUrl = true) => {
      const selected = [...root.querySelectorAll('.sc-pdp-option')].map((field) => {
        const checked = field.querySelector('[data-sc-option]:checked');
        field.querySelector('[data-sc-option-label]').textContent = checked?.value || '';
        return checked?.value;
      });
      const currentId = root.querySelector('[data-sc-variant-id]')?.value;
      const variant = selected.length
        ? variants.find((item) => item.options.every((value, i) => value === selected[i]))
        : variants.find((item) => String(item.id) === String(currentId)) || variants.find((item) => item.available) || variants[0];
      if (!variant) return;
      root.querySelector('[data-sc-variant-id]').value = variant.id;
      const price = root.querySelector('[data-sc-price]');
      price.innerHTML = renderPrice(variant);
      const add = root.querySelector('[data-sz-add]');
      add.disabled = !variant.available;
      add.querySelector('[data-sz-add-label]').textContent = variant.available ? labels.add : labels.soldOut;
      const mobileAdd = root.querySelector('[data-sc-mobile-add]');
      mobileAdd.disabled = !variant.available;
      mobileAdd.querySelector('span').textContent = variant.available ? labels.add : labels.soldOut;
      root.querySelector('[data-sc-mobile-price]').textContent = variant.price;
      const mobileSelection = root.querySelector('[data-sc-mobile-selection]');
      if (mobileSelection && variant.options?.length) mobileSelection.textContent = variant.options.join(' / ');
      root.querySelector('[data-sz-cart-status]')?.replaceChildren();
      root.querySelector('[data-sc-stock]').innerHTML = variant.available ? `<span></span>${labels.inStock}` : labels.soldOut;
      const dynamicCheckout = root.querySelector('.sc-pdp-dynamic');
      if (dynamicCheckout) dynamicCheckout.hidden = !variant.available;
      const restock = root.querySelector('[data-sc-restock]');
      if (restock && !restock.querySelector('[data-sc-restock-success]')) restock.hidden = variant.available;
      const restockVariant = root.querySelector('[data-sc-restock-variant]');
      if (restockVariant) restockVariant.value = variant.options.join(' / ');
      if (variant.mediaId) {
        const mediaIndex = slides.findIndex((slide) => String(slide.dataset.mediaId) === String(variant.mediaId));
        if (mediaIndex >= 0) showSlide(mediaIndex);
      }
      if (updateUrl) {
        const url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', url);
      }
    };
    optionInputs.forEach((input) => input.addEventListener('change', () => updateVariant(true)));
    const initialVariantId = root.querySelector('[data-sc-variant-id]')?.value;
    const initialVariant = variants.find((item) => String(item.id) === String(initialVariantId));
    if (initialVariant?.mediaId) {
      const initialMediaIndex = slides.findIndex((slide) => String(slide.dataset.mediaId) === String(initialVariant.mediaId));
      if (initialMediaIndex > 0) showSlide(initialMediaIndex);
    }

    const mainPurchase = root.querySelector('.sc-pdp-purchase');
    const mobileBar = root.querySelector('[data-sc-mobile-bar]');
    const singleVariant = root.dataset.singleVariant === 'true';
    const mainAdd = root.querySelector('[data-sz-add]');
    const mobileAdd = root.querySelector('[data-sc-mobile-add]');
    const mobileAddLabel = mobileAdd?.querySelector('span');
    const syncMobileAdd = () => {
      if (!mainAdd || !mobileAdd || !mobileAddLabel) return;
      const mainLabel = mainAdd.querySelector('[data-sz-add-label]')?.textContent?.trim();
      mobileAdd.disabled = mainAdd.disabled;
      mobileAdd.classList.toggle('is-loading', mainAdd.classList.contains('is-loading'));
      mobileAdd.setAttribute('aria-busy', mainAdd.classList.contains('is-loading') ? 'true' : 'false');
      if (mainLabel) mobileAddLabel.textContent = mainLabel;
    };
    mobileAdd?.addEventListener('click', () => {
      if (!mainAdd || mainAdd.disabled) return;
      mobileAdd.disabled = true;
      mobileAdd.classList.add('is-loading');
      mobileAdd.setAttribute('aria-busy', 'true');
      if (mobileAddLabel) mobileAddLabel.textContent = root.dataset.labelAdding;
      mainAdd.click();
      queueMicrotask(syncMobileAdd);
    });
    if (mainAdd) new MutationObserver(syncMobileAdd).observe(mainAdd, { attributes: true, childList: true, subtree: true });
    if (mainPurchase && mobileBar && window.matchMedia('(max-width: 749px)').matches) {
      const observer = new IntersectionObserver(([entry]) => {
        const visible = !entry.isIntersecting && (singleVariant || entry.boundingClientRect.bottom <= 0);
        mobileBar.classList.toggle('is-visible', visible);
        root.classList.toggle('has-mobile-buy-bar', visible);
      }, { threshold: 0.1 });
      observer.observe(mainPurchase);
    }

    root.querySelectorAll('[data-sc-tabs]').forEach((tabs) => {
      const buttons = [...tabs.querySelectorAll('[data-sc-tab]')];
      const panels = [...tabs.querySelectorAll('[data-sc-panel]')];
      const activateTab = (button, moveFocus = false) => {
        buttons.forEach((item) => {
          const active = item === button;
          item.classList.toggle('is-active', active);
          item.setAttribute('aria-selected', active ? 'true' : 'false');
          item.tabIndex = active ? 0 : -1;
        });
        panels.forEach((panel) => {
          const active = panel.dataset.scPanel === button.dataset.scTab;
          panel.hidden = !active;
          panel.classList.toggle('is-active', active);
        });
        if (moveFocus) button.focus();
      };
      buttons.forEach((button, index) => {
        button.addEventListener('click', () => activateTab(button));
        button.addEventListener('keydown', (event) => {
          let nextIndex;
          if (event.key === 'ArrowRight') nextIndex = (index + 1) % buttons.length;
          if (event.key === 'ArrowLeft') nextIndex = (index - 1 + buttons.length) % buttons.length;
          if (event.key === 'Home') nextIndex = 0;
          if (event.key === 'End') nextIndex = buttons.length - 1;
          if (nextIndex === undefined) return;
          event.preventDefault();
          activateTab(buttons[nextIndex], true);
        });
      });
    });

    const descriptionCopy = root.querySelector('[data-sc-description-copy]');
    const descriptionToggle = root.querySelector('[data-sc-description-toggle]');
    if (descriptionCopy && descriptionToggle) {
      const mobileQuery = window.matchMedia('(max-width: 749px)');
      const configureDescription = () => {
        if (!mobileQuery.matches) {
          descriptionCopy.classList.remove('is-collapsible', 'is-expanded');
          descriptionToggle.hidden = true;
          descriptionToggle.setAttribute('aria-expanded', 'false');
          descriptionToggle.textContent = descriptionToggle.dataset.labelMore;
          return;
        }
        descriptionCopy.classList.remove('is-collapsible');
        const needsToggle = descriptionCopy.scrollHeight > 264;
        descriptionCopy.classList.toggle('is-collapsible', needsToggle);
        descriptionToggle.hidden = !needsToggle;
      };
      descriptionToggle.addEventListener('click', () => {
        const expanded = descriptionCopy.classList.toggle('is-expanded');
        descriptionToggle.setAttribute('aria-expanded', expanded ? 'true' : 'false');
        descriptionToggle.textContent = expanded ? descriptionToggle.dataset.labelLess : descriptionToggle.dataset.labelMore;
      });
      mobileQuery.addEventListener?.('change', configureDescription);
      requestAnimationFrame(configureDescription);
    }
  };

  const initRecommendations = (section) => {
    if (section.dataset.scReady === 'true' || section.getAttribute('aria-busy') !== 'true') return;
    section.dataset.scReady = 'true';
    const loadRecommendations = () => {
      fetch(section.dataset.url, { credentials: 'same-origin' })
        .then((response) => response.text())
        .then((markup) => {
          const page = new DOMParser().parseFromString(markup, 'text/html');
          const updated = page.querySelector('[data-sc-recommendations]');
          if (updated) section.innerHTML = updated.innerHTML;
          section.removeAttribute('aria-busy');
        })
        .catch(() => section.removeAttribute('aria-busy'));
    };

    if ('IntersectionObserver' in window) {
      const observer = new IntersectionObserver((entries) => {
        if (!entries.some((entry) => entry.isIntersecting)) return;
        observer.disconnect();
        loadRecommendations();
      }, { rootMargin: '800px 0px' });
      observer.observe(section);
    } else {
      loadRecommendations();
    }
  };

  const initRecentlyViewed = (section) => {
    if (section.dataset.scReady === 'true') return;
    section.dataset.scReady = 'true';
    let viewedProducts = [];
    try { viewedProducts = JSON.parse(localStorage.getItem('viewedProducts') || '[]'); } catch (_) { viewedProducts = []; }
    const currentId = String(section.dataset.productId || '');
    const ids = viewedProducts.map(String).filter((id) => id && id !== currentId).slice(0, 4);
    if (!ids.length) return;
    const url = new URL(section.dataset.searchUrl, window.location.origin);
    url.searchParams.set('view', 'sc-recent');
    url.searchParams.set('type', 'product');
    url.searchParams.set('q', ids.map((id) => `id:${id}`).join(' OR '));
    fetch(url, { credentials: 'same-origin' })
      .then((response) => response.text())
      .then((markup) => {
        const page = new DOMParser().parseFromString(markup, 'text/html');
        const cards = [...page.querySelectorAll('.sc-recent-results > [data-product-id]')];
        cards.sort((a, b) => ids.indexOf(a.dataset.productId) - ids.indexOf(b.dataset.productId));
        if (!cards.length) return;
        section.querySelector('[data-sc-recent-grid]').replaceChildren(...cards);
        section.hidden = false;
      });
  };

  const initReviewTrust = (section) => {
    if (section.dataset.scReviewTrustReady) return;
    section.dataset.scReviewTrustReady = 'queued';

    const activateReviewTrust = () => {
      if (section.dataset.scReviewTrustReady === 'true') return;
      section.dataset.scReviewTrustReady = 'true';
      const reviewCache = new Map();
      const labels = {
        imported: section.dataset.labelImportedReview,
        verified: section.dataset.labelVerifiedPurchase,
        unverified: section.dataset.labelUnverifiedPurchase
      };
      const cacheReviewData = (payload) => {
        if (!payload || typeof payload !== 'object') return;
        if (Array.isArray(payload)) {
          payload.forEach(cacheReviewData);
          return;
        }
        if (typeof payload.uuid === 'string' && ('verified_buyer' in payload || 'transparency_badges' in payload)) {
          reviewCache.set(payload.uuid, payload);
        }
        Object.values(payload).forEach(cacheReviewData);
      };
      const enhanceReviews = () => {
        Object.values(window.jdgm?.data?.reviewWidget || {}).forEach(cacheReviewData);
        section.querySelectorAll('.jm-review-item[review-uuid]').forEach((item) => {
          if (item.querySelector('[data-sc-review-trust]')) return;
          const review = reviewCache.get(item.getAttribute('review-uuid'));
          if (!review) return;
          const imported = Array.isArray(review.transparency_badges)
            && review.transparency_badges.includes('review_collected_from_another_provider');
          const statusLabels = [];
          if (imported && labels.imported) statusLabels.push(labels.imported);
          if (review.verified_buyer === true && labels.verified) statusLabels.push(labels.verified);
          if (review.verified_buyer === false && labels.unverified) statusLabels.push(labels.unverified);
          if (!statusLabels.length) return;
          const badge = document.createElement('span');
          badge.className = 'sc-review-trust-badge';
          badge.dataset.scReviewTrust = '';
          badge.textContent = statusLabels.join(' · ');
          const anchor = item.querySelector('.jm-reviewer-info__details');
          if (anchor) anchor.append(badge);
        });
        section.querySelectorAll('.jm-shop-reply').forEach((reply) => {
          const text = reply.textContent.replace(/\s+/g, ' ').trim();
          if (/^Reply from SHANZHUI:\s*Thank you for the feedback!?$/i.test(text)) reply.hidden = true;
        });
      };
      if (!window.__scReviewTrustFetchWrapped) {
        window.__scReviewTrustFetchWrapped = true;
        const originalFetch = window.fetch.bind(window);
        window.fetch = (...args) => originalFetch(...args).then((response) => {
          const requestUrl = typeof args[0] === 'string' ? args[0] : args[0]?.url || '';
          if (/cdn\.judge\.me\/reviews\/reviews_for_widget/i.test(requestUrl)) {
            response.clone().json().then((payload) => {
              cacheReviewData(payload);
              enhanceReviews();
            }).catch(() => {});
          }
          return response;
        });
      }
      enhanceReviews();
      const observer = new MutationObserver(enhanceReviews);
      observer.observe(section, { childList: true, subtree: true });
    };

    if ('IntersectionObserver' in window && !window.Shopify?.designMode) {
      const observer = new IntersectionObserver((entries) => {
        if (!entries.some((entry) => entry.isIntersecting)) return;
        observer.disconnect();
        activateReviewTrust();
      }, { rootMargin: '800px 0px' });
      observer.observe(section);
    } else {
      activateReviewTrust();
    }
  };

  const initAll = (scope = document) => {
    scope.querySelectorAll('[data-sc-product-root]').forEach(initProduct);
    scope.querySelectorAll('[data-sc-recommendations]').forEach(initRecommendations);
    scope.querySelectorAll('[data-sc-recent-root]').forEach(initRecentlyViewed);
    scope.querySelectorAll('.sc-product-reviews').forEach(initReviewTrust);
  };
  document.addEventListener('DOMContentLoaded', () => initAll());
  document.addEventListener('shopify:section:load', (event) => initAll(event.target));
})();
